
import { Whitelabel, whitelabels } from '../../utils/whitelabels';
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';

import CPOptionDropdown from '@/components/open-account/input/CPOptionDropdown.vue';

import { AccountSummary } from '@/definitions/definitions';

@Component({
  components: {
    CPOptionDropdown,
  },
})
export default class CPGlobalAccountSelect extends Vue {
  @Prop({ required: true, default: false })
  public active!: boolean;

  public accountList: any[] = [];

  public activeAccount = this.accountList[0] ? this.accountList[0] : null;

  public whitelabelLogo: any = whitelabels[0].logo;

  get subdomain() {
    return this.$store.state.subdomain;
  }

  get moventumId(): string {
    return this.$store.state.account.accountSummary.moventumId;
  }

  // account details

  get accountSummary() {
    return this.$store.state.account.accountSummary;
  }
  get activeAccountSummary() {
    return this.getActiveAccountDetails(this.accountSummary);
  }
  get activeAccountNumber(): number {
    return this.$store.state.account.details.activeAccountId;
  }
  get token() {
    return this.$store.state.account.token;
  }
  get accounts() {
    return this.$store.state.account.accountSummary;
  }

  @Watch('subdomain')
  public updateWhitelabel() {
    if (!this.subdomain) {
      this.whitelabelLogo = whitelabels[0].logo;
    } else {
      const companyIndex = whitelabels
        .map((x) => x.name())
        .indexOf(this.subdomain);
      this.whitelabelLogo = whitelabels[companyIndex].logo;
    }
  }

  @Watch('accounts')
  public sortAccounts() {
    const sortedAccounts: any[] = [];
    this.accounts.forEach((account: any) => {
      account.text = account.type.replace('Account', '');
      account.value = account.id;
      sortedAccounts.push(account);
    });
    this.accountList = sortedAccounts;
  }

  @Watch('activeAccountNumber')
  public setActiveAccount() {
    const newActiveAccount: any[] = this.accountList.filter(
      (account) => account.id === this.activeAccountNumber,
    );
    this.$nextTick(() => {
      this.activeAccount = newActiveAccount[0];
    });
  }

  @Watch('activeAccount', { deep: true })
  public updateActiveAccount() {
    if (this.activeAccount) {
      this.updateAccountDetails(this.activeAccount.id);
    }
  }

  public async updateAccountDetails(accNum: number) {
    await this.$store.dispatch('setActiveAccountId', accNum);
  }

  public getActiveAccountDetails(arr: AccountSummary[]) {
    const newArr: AccountSummary[] = arr.filter(
      (item: AccountSummary) => item.id === this.activeAccountNumber,
    );
    this.$store.dispatch('setActiveAccount', newArr[0]);
    return newArr[0];
  }

  public mounted() {
    this.updateWhitelabel();
  }
}
